module.exports = __webpack_public_path__ + "static/media/step4a.232de1ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Tour/assets/step4a.png
// module id = 3742
// module chunks = 0